import { Pipe, PipeTransform } from '@angular/core';
import { ETipoDocumento } from '@core/enums/tipoDocumento.enum';

@Pipe({
  name: 'tipo_documento',
})
export class TipoDocumentoPipe implements PipeTransform {
  transform(value: ETipoDocumento | string): string {
    if (!value) return '-';

    const map: Record<string, string> = {
      [ETipoDocumento.DNI]: 'DNI',
      [ETipoDocumento.RUC]: 'RUC',
      [ETipoDocumento.CE]: 'Carnet de Extranjería',
      [ETipoDocumento.PASAPORTE]: 'Pasaporte',
      [ETipoDocumento.PERMISO_TEMPORAL_PERMANENCIA]: 'Permiso Temporal de Permanencia',
      [ETipoDocumento.DOCUMENTO_IDENTIDAD_EXTRANJERO]: 'Documento de Identidad Extranjero',
      [ETipoDocumento.OTRO]: 'Otro',
    };

    return map[value] ?? value;
  }
}
